/*
  a11y-slider-focus.js
  Fixes the Lighthouse warning "[aria-hidden="true"] elements contain focusable
  descendents" for Flickity sliders. Flickity marks off-screen cells with
  aria-hidden="true" but leaves their links/buttons keyboard-focusable, which
  traps focus on invisible content. This script makes focusable descendants of
  any aria-hidden Flickity cell non-focusable, and restores them when the cell
  becomes visible again. It is purely additive and does not touch slider logic.
*/
(function () {
  var FOCUSABLE = 'a[href], button, input, select, textarea, iframe, [tabindex]';

  function applyCell(cell) {
    var hidden = cell.getAttribute('aria-hidden') === 'true';
    cell.querySelectorAll(FOCUSABLE).forEach(function (el) {
      if (hidden) {
        if (!el.hasAttribute('data-a11y-prev-tabindex')) {
          el.setAttribute('data-a11y-prev-tabindex', el.getAttribute('tabindex') || '');
        }
        el.setAttribute('tabindex', '-1');
      } else if (el.hasAttribute('data-a11y-prev-tabindex')) {
        var prev = el.getAttribute('data-a11y-prev-tabindex');
        if (prev === '') {
          el.removeAttribute('tabindex');
        } else {
          el.setAttribute('tabindex', prev);
        }
        el.removeAttribute('data-a11y-prev-tabindex');
      }
    });
  }

  function scan(root) {
    (root || document).querySelectorAll('.flickity-cell').forEach(applyCell);
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      var target = m.target;
      if (target.nodeType === 1 && target.classList.contains('flickity-cell')) {
        applyCell(target);
      }
    });
  });

  function init() {
    scan(document);
    observer.observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden'],
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
